import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { OrderData, Quote } from '@zero/shared/util-models';
import { OrderState } from './order.reducers';

export const orderActions = createActionGroup({
  source: 'Order',
  events: {
    'Load Orders': props<{ category: keyof OrderState; force: boolean; size: number }>(),
    'Set Loading': props<{ category: keyof OrderState; loading: boolean }>(),
    'Increment Order Page': props<{ category: keyof OrderState }>(),
    'Reset Order': props<{ category: keyof OrderState }>(),
    'Update Open Orders Quotes': props<Record<string, Quote>>(),
    'Unsubscribe from Open Orders Quotes': emptyProps(),
    'Unsubscribe from Open Order Quote': props<{ orderId: string }>(),
    'Update Open Order Stop Price': props<{ orderId: string; stopPrice: number }>(),
  },
});

export const orderApiActions = createActionGroup({
  source: 'Order API',
  events: {
    'Load Orders Success': props<{ category: keyof OrderState; orders: OrderData[]; hasNext: boolean }>(),
    'Load Orders Failure': props<{ category: keyof OrderState; error: HttpErrorResponse }>(),
  },
});

export const orderActionsIgnoreList = [orderActions.updateOpenOrdersQuotes.type];
